import React from "react"
import ContentLoader from "react-content-loader";

const KanbanItem = (props) => {
    return(
      <ContentLoader viewBox="0 300 110" height={130} width={400} {...props}>
      <circle cx="10" cy="20" r="6" />
      <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
      <circle cx="10" cy="50" r="6" />
      <rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
      <circle cx="10" cy="80" r="6" />
      <rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
      <circle cx="10" cy="110" r="6" />
      <rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
    )
  
}

export default KanbanItem